angular.module('impactx.lot').controller('LotCtrl', [
    '$scope',
    '$sce',
    '$mdDialog',
    'dataGen',
    '$routeParams',
    '$context',
    'searchFilter',
    'panelService',
    'RFXCreateService',
    'AppConfiguration',
    'SearchService',
    'ToolbarService',
    'SearchFilterStorage',
    'SearchFilter',
    '$rootScope',
    '$location',
    'SearchExecution',
    'ProductViewService',
    'TranslationService',
    'ThemeWorldService',
    '$redirect',
    LotCtrl
]);

function LotCtrl($scope, $sce, $mdDialog, dataGen, $routeParams, $context, searchFilter, panelService, RFXCreateService,
                 AppConfiguration, SearchService, ToolbarService, SearchFilterStorage, SearchFilter, $rootScope, $location, SearchExecution, 
                 ProductViewService, TranslationService, ThemeWorldService, $redirect) {
    var lotCtrl = this;
    lotCtrl.lotId = $routeParams.id;
    lotCtrl.getLotPanelColor = panelService.getLotPanelColor;
    var scrollPositionList = 0;
    this.translationService = TranslationService;
    this.panelsInitialized = false;
    this.showScrollTopButton = false;
    this.pageNumber = 1;
    this.expandCatalogSupplierDefault = SearchService.userSearchConfig('expandCatalogSupplierDefault');
    this.showSupplierSearch = AppConfiguration.get('showSupplierSearch');
    this.displayAllResultsAsList = AppConfiguration.get('displayAllResultsAsList');
    this.informationIsOpen = SearchService.userSearchConfig('informationIsOpen');
    this.showPanelLabel = AppConfiguration.get('showPanelLabels');
    this.SearchFilter = SearchFilter;
    ToolbarService.showSearchFilterToggle();
    this.filterNeedsReset = {value: false};
    lotCtrl.searchWithReset = function (item) {
        lotCtrl.filterNeedsReset.value = true;
        SearchFilter.setSearchInputClassification(null);
        var freshFilter = SearchFilterStorage.getFreshFilter();
        if (freshFilter) {
            lotCtrl.filter = freshFilter;
            lotCtrl.filter.lotId = {value: $routeParams.id};
            lotCtrl.filter.dialogFilter = "lot";
            SearchFilterStorage.setLotFilter($routeParams.id, lotCtrl.filter);
            lotCtrl.filter.searchInput.value = searchFilter.searchInput;
            if (item) {
                if (item.isClassification) {
                    lotCtrl.filter.guidingClassification.selected = {id: item.id, value: item.value};
                }
            }
            SearchFilter.setFilters(lotCtrl.filter);
        }
        lotCtrl.searchAll();
    }

    var currentLocation = $location.path();
    var backButtonUsed = $rootScope.location !== currentLocation;
    var storedSearchFilterObject = SearchFilterStorage.getLotFilter($routeParams.id);
    if (storedSearchFilterObject && ($routeParams.useSetFilter || storedSearchFilterObject.searchInputUsed || backButtonUsed)) {
        storedSearchFilterObject.searchInputUsed = false;
        lotCtrl.filter = storedSearchFilterObject;
        searchFilter.searchInput = lotCtrl.filter.searchInput.value;
        var guidingClassification =  lotCtrl.filter.guidingClassification;
        if (guidingClassification && guidingClassification.superEntries) {
            var superEntry = guidingClassification.superEntries[guidingClassification.superEntries.length - 1];
            SearchFilter.setSearchInputClassification(superEntry);
        }
        else {
            SearchFilter.setSearchInputClassification(null);
        }
        if(!lotCtrl.filter.productsPerPage)
        {
            lotCtrl.filter.productsPerPage = SearchService.getNumberOfProductRows();
        }
        SearchFilter.setFilters(lotCtrl.filter);
        getDialogData(backButtonUsed);
    }
    else {
        SearchFilter.setSearchInputClassification(null);
        var freshFilter = SearchFilterStorage.getFreshFilter();
        if (freshFilter) {
            lotCtrl.filter = freshFilter;
            lotCtrl.filter.lotId = {value: $routeParams.id};
            lotCtrl.filter.dialogFilter = "lot";
            SearchFilterStorage.setLotFilter($routeParams.id, lotCtrl.filter);
            searchFilter.searchInput = lotCtrl.filter.searchInput.value;
            SearchFilter.setFilters(lotCtrl.filter);
            getDialogData();
        }
        else {
            var result = {};
            dataGen.getData(result, {}, "/search/filter", null, true).then(function () {
                SearchFilterStorage.setFreshFilter(result.data);
                lotCtrl.filter = result.data;
                lotCtrl.filter.lotId = {value: $routeParams.id};
                lotCtrl.filter.dialogFilter = "lot";
                SearchFilterStorage.setLotFilter($routeParams.id, lotCtrl.filter);
                if ($location.path() === currentLocation) {
                    //only if we are still on the vCatalog page.
                    searchFilter.searchInput = lotCtrl.filter.searchInput.value;
                    SearchFilter.setFilters(lotCtrl.filter);
                    getDialogData()
                }
            });
        }
    }

    function getDialogData(backButtonUsed)
    {
        return dataGen.getData($scope, {id: $routeParams.id}, "/lot/view").then(function () {
            lotCtrl.searchAll(true).then(function () {
                lotCtrl.panelsInitialized = true;
                handleNoProducts();
                if(backButtonUsed) {
                    SearchFilterStorage.scrollToSearchScrollPosition("lot", '#search-view');
                }
            });
            $scope.description = $sce.trustAsHtml($scope.data.description);
            $scope.showDescriptionMore = $scope.data.description && $scope.data.description.length > 500;

            $scope.themeWorldActive = $scope.data.themeWorldActive;
            $scope.no_result = $scope.themeWorldActive && $scope.noSearchResults;

            $scope.showDialog = function () {
                $mdDialog.show({
                    templateUrl: './modules/lot/newrequest.tmpl.html',
                    clickOutsideToClose: true,
                    escapeToClose: false,
                    fullscreen: false
                });
            };
            $scope.trns.addToThemeWorld = TranslationService.get('addToThemeWorld');
            $scope.trns.removeFromThemeWorld = TranslationService.get('removeFromThemeWorld');
            $scope.trns.addToProductView = TranslationService.get('addToProductView');
            $scope.trns.removeFromProductView = TranslationService.get('removeFromProductView');
            $scope.trns.showAll = TranslationService.get("showAll");

            defineButtons();
        });
    }

    $scope.$on('$routeChangeStart', function (event, newRoute, oldRoute) {
        var detailList = newRoute.originalPath.indexOf("/search.") > - 1;
        if (!detailList && newRoute.originalPath !== "/search") {
            SearchFilter.setSearchInputClassification(null);
            searchFilter.searchInput = "";
            SearchFilter.setFilters(SearchFilterStorage.getFreshFilter());
        }
        if (newRoute.$$route.originalPath !== oldRoute.$$route.originalPath) {
            SearchFilterStorage.setSearchFilterPlaceHolder(null);
            SearchFilterStorage.setSearchScrollPosition("lot", document.getElementById('search-view').scrollTop);
        }
    });
    
    this.createScrollList = function () {
        $scope.scrollList = [];
        if (lotCtrl.catalogs) {
            var numberOfVCats = lotCtrl.numberOfCatalogs;
            if (numberOfVCats > 1) {
                $scope.scrollList.push({id: "catalogsAndSuppliers", label: numberOfVCats + " " + $scope.trns.vcats, func: openCatalogArea})
            }
            if (numberOfVCats === 1) {
                $scope.scrollList.push({id: "catalogsAndSuppliers", label: numberOfVCats + " " + $scope.trns.vcat, func: openCatalogArea})
            }
        }
        if (lotCtrl.suppliers) {
            var numberOfSuppliers = lotCtrl.numberOfSuppliers;
            if (numberOfSuppliers > 1) {
                $scope.scrollList.push({
                    id: "catalogsAndSuppliers",
                    label: numberOfSuppliers + " " + $scope.trns.suppliers,
                    func: openSupplierArea
                })
            }
            if (numberOfSuppliers === 1) {
                $scope.scrollList.push({
                    id: "catalogsAndSuppliers",
                    label: numberOfSuppliers + " " + $scope.trns.supplier,
                    func: openSupplierArea
                })
            }
        }
        var numberOfPros = lotCtrl.numberOfProducts;
        if (numberOfPros > 1) {
            $scope.scrollList.push({id: "pro", label: numberOfPros + " " + $scope.trns.products})
        }
        if (numberOfPros === 1) {
            $scope.scrollList.push({id: "pro", label: numberOfPros + " " + $scope.trns.product})
        }
        if ($scope.scrollList.length > 0) {
            $scope.scrollList.unshift({id: "header", label: $scope.trns.headerData, func: openHeaderArea});
        }
        ToolbarService.setScrollMenu($scope.scrollList)
    };

    this.canShowFreeformItemDialog = function () {
        return AppConfiguration.get('useFFClassicDialog') && $scope.data && $scope.data.isFreeFormAllowed;
    };

    this.canShowFreeformOfferDialog = function () {
        return AppConfiguration.get('useFFOfferDialog') && $scope.data && $scope.data.isFreeFormAllowed;
    };

    this.showBasketItemDialog = function (ev) {
        var basketItemId = 0;

        var entryPointGet = "/basket/item/freeform/view";
        var entryPointSave = "/basket/item/freeform/save";
        var controller = "EditFreeFormCtrl";

        $mdDialog.show({
            controller: controller,
            templateUrl: 'shared/requestitem/templates/requestitemdialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                itemId: basketItemId,
                headerId: 0,
                entryPointGet: entryPointGet,
                entryPointSave: entryPointSave,
                changeAATEntryPoint: '/basket/item/updateavailablecontrols',
                lotId: $routeParams.id,
                productId: -1,
                readOnly: false,
                materialGroupMappingEntryPoint: "/basket/input/eclassmapping",
                hideOrderData: false,
                headerTable: "BKH",
                contractId: 0
            }
        })
            .then(function () {
                $context.refreshBasket({}, dataGen, $context);
            }, function () {
            });
    };

    this.showBasketItemOfferDialog = function (ev) {
        $mdDialog.show({
            controller: "EditFreeFormOfferCtrl",
            controllerAs: "editFreeFormOfferCtrl",
            templateUrl: 'modules/basket/templates/freeformofferdialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                basketItemGroupId: 0, // new group
                headerId: 0, // current basket
                hideOrderData: false, // show comments
                lotId: $routeParams.id, // reduce to current lot
                supplierId: 0, // no fixed supplier
                product: null,
                allowBANF: false,
                onlyBANF: false
            }
        })
            .then(function () {
                $context.refreshBasket({}, dataGen, $context);
            }, function () {
            });
    };

    this.createRFX = function () {
        RFXCreateService.createRFX("lot", $routeParams.id);
    };

    this.showScrollTop = function (showScrollTop, scrollPosition) {
        lotCtrl.showScrollTopButton = showScrollTop;
        scrollPositionList = scrollPosition;
    };

    this.searchProducts = function (index, selectedSort) {
        lotCtrl.filter.productPageNumber = index;
        lotCtrl.filter.productsPerPage = SearchService.getNumberOfProductRows();
        if (selectedSort) {
            lotCtrl.filter.sort.selected = selectedSort;
        }
        return SearchService.searchProducts(lotCtrl.filter.productPageNumber).then(function (searchResults) {
            if (searchResults) {
                angular.extend(lotCtrl, searchResults);
            }
        })
    };

    this.searchAll = function (onInit) {
        if (!onInit && lotCtrl.filter) {
            lotCtrl.filter.productPageNumber = 1;
        }
        return SearchService.searchAll().then(function (searchResult) {
            angular.extend(lotCtrl, searchResult);
            lotCtrl.createScrollList();
            $scope.noSearchResults = searchResult.catalogs.length === 0 && (!searchResult.suppliers || searchResult.suppliers.length === 0) &&
                searchResult.products.length === 0;
            $scope.no_result = $scope.themeWorldActive && $scope.noSearchResults;
        });
    };

    this.scrollToTop = function () {
        angular.element('#search-view').animate({
            scrollTop: scrollPositionList
        }, 200);
    };

    this.toggleInformation = function () {
        lotCtrl.informationIsOpen = !lotCtrl.informationIsOpen
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.freeFormItem,
                action: lotCtrl.showBasketItemDialog,
                type: 'dialogaction',
                condition: lotCtrl.canShowFreeformItemDialog,
            },
            {
                label: $scope.trns.addFreeFormOffer,
                action: lotCtrl.showBasketItemOfferDialog,
                type: 'dialogaction',
                condition: lotCtrl.canShowFreeformOfferDialog
            },
            {
                label: $scope.trns.createRFX,
                action: lotCtrl.createRFX,
                type: 'dialogaction',
                condition: lotCtrl.canCreateRFX
            },
            {
                label: $scope.trns.addToProductView,
                action: lotCtrl.addToProductView,
                type: 'dialogaction',
                condition: canAddToProductView
            },
            {
                label: $scope.trns.removeFromProductView,
                action: lotCtrl.removeFromProductView,
                type: 'dialogaction',
                condition: canRemoveFromProductView
            },
            {
                label: $scope.trns.addToThemeWorld,
                action: lotCtrl.addToThemeWorld,
                type: 'dialogaction',
                condition: canAddToThemeWorld
            },
            {
                label: $scope.trns.removeFromThemeWorld,
                action: lotCtrl.removeFromThemeWorld,
                type: 'dialogaction',
                condition: canRemoveFromThemeWorld
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canAddToProductView() {
        return $scope.data.canAddToProductView;
    }

    function canRemoveFromProductView() {
        return $scope.data.canRemoveFromProductView;
    }

    function canAddToThemeWorld() {
        return $scope.data.canAddToThemeWorld;
    }

    function canRemoveFromThemeWorld() {
        return $scope.data.canRemoveFromThemeWorld;
    }

    lotCtrl.addToProductView = function($event) {
        $scope.data.canAddToProductView = false;
        $scope.data.canRemoveFromProductView = true;
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.addLotsToProductView([$scope.data]);
    };

    lotCtrl.removeFromProductView = function($event) {
        var vcatIds = [];
        $scope.data.canAddToProductView = true;
        $scope.data.canRemoveFromProductView = false;
        vcatIds.push($scope.data.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.removeLotsFromProductView($context.hasActiveProductView.id, vcatIds);
    };

    lotCtrl.addToThemeWorld = function($event) {
        $scope.data.canAddToThemeWorld = false;
        $scope.data.canRemoveFromThemeWorld = true;
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.addLotsToThemeWorld([$scope.data]);
    };

    lotCtrl.removeFromThemeWorld = function($event) {
        var vcatIds = [];
        $scope.data.canAddToThemeWorld = true;
        $scope.data.canRemoveFromThemeWorld = false;
        vcatIds.push($scope.data.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.removeLotsFromThemeWorld($context.hasActiveThemeWorld.id, vcatIds);
    };

    
    this.canCreateRFX = function () {
        return $scope.data.showRFXButton;
    }

    function openCatalogArea() {
        lotCtrl.expandCatalogSupplierDefault = true;
        lotCtrl.catalogPaneSelected = true;
        lotCtrl.supplierPaneSelected = false;
    }

    function openSupplierArea() {
        lotCtrl.expandCatalogSupplierDefault = true;
        lotCtrl.catalogPaneSelected = false;
        lotCtrl.supplierPaneSelected = true;
    }

    function openHeaderArea() {
        lotCtrl.informationIsOpen = true;
    }

    $scope.$on('$destroy', function () {
        SearchService.setUserSearchConfigParameter('expandCatalogSupplierDefault', lotCtrl.expandCatalogSupplierDefault);
        SearchService.setUserSearchConfigParameter('informationIsOpen', lotCtrl.informationIsOpen);
        ToolbarService.hideSearchFilterToggle();
    });

    $scope.$on('MainSearchTriggered', function () {
        lotCtrl.informationIsOpen = false;
    });

    lotCtrl.updateCatalogs = function (pageNumber, pageSize) {
        SearchFilter.setLotId(lotCtrl.lotId);
        return SearchExecution.searchCatalogs(SearchFilter.getFilters(), pageSize, pageNumber).then(function (result) {
            var numberOfResults = 0;
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                lotCtrl.catalogs = lotCtrl.catalogs.concat(searchResults.catalogs);
                numberOfResults = searchResults.catalogs.length;
            }
            return numberOfResults;
        })
    };

    lotCtrl.updateSuppliers = function (pageNumber, pageSize) {
        SearchFilter.setLotId(lotCtrl.lotId);
        return SearchExecution.searchSuppliers(SearchFilter.getFilters(), pageSize, pageNumber).then(function (result) {
            var numberOfResults = 0;
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                lotCtrl.suppliers = lotCtrl.suppliers.concat(searchResults.suppliers);
                numberOfResults = searchResults.suppliers.length;
            }
            return numberOfResults;
        })
    };

    lotCtrl.redirectToContacts = function () {
        $redirect.redirectTo(null, "search.contact/lot/" + lotCtrl.lotId);
    }

    function handleNoProducts() {
        if (!lotCtrl.products ||lotCtrl.products.length == 0) {
            openSupplierArea();
        }
    }

    lotCtrl.anyResults = function () {
        return (lotCtrl.showSupplierSearch && lotCtrl.suppliers && lotCtrl.suppliers.length > 0) ||
            (lotCtrl.catalogs && lotCtrl.catalogs.length > 0) ||
            (lotCtrl.products && lotCtrl.products.length > 0);
    };

    lotCtrl.getFilterAmount = function() {
        // Ignore 2 filters
        return lotCtrl.SearchFilter.selectedFilter.amount
            + (lotCtrl.filter.productFamily && lotCtrl.filter.productFamily.selected? -1 : 0)
            + (lotCtrl.filter.procurementGroup && lotCtrl.filter.procurementGroup.selected? -1 : 0);
    }
    lotCtrl.showNoResultsHint = function () {
        return !$context.hasActiveThemeWorldSearch || !$context.hasActiveThemeWorldSearch.value;
    }

    this.searchTerm = function (term) {
        SearchFilter.setFilterIdentifier();
        searchFilter.searchInput = term;

        SearchFilter.setFilters(SearchFilterStorage.getFreshFilter())

        SearchFilter.getFilters().lotId = {value: $routeParams.id};
        SearchFilter.getFilters().dialogFilter = "lot";
        SearchFilterStorage.setLotFilter($routeParams.id, SearchFilter.getFilters());

        searchFilter.resetDetailFilter().then(function () {
            var filterData = {};
            if ($context.hasActiveShopView.value) {
                searchFilter.listSearch.value = true;
            }
            SearchFilter.getFilters().searchInput.value = searchFilter.searchInput;
            SearchFilter.getFilters().searchInputUsed = true;
            lotCtrl.searchWithReset();
        });
    };
}
